// extracted by mini-css-extract-plugin
module.exports = {"categoryPageWrap":"category_categoryPageWrap__5jLLn"};